export default __webpack_public_path__ + "static/media/PayPal.94dc1a6e.svg";